import React from 'react';
import loadable from '@loadable/component'

import withPage, { fetchSlugInfo } from '../page';

const HomePage = loadable(() => import('./components'));

const loadData = async (urlParams, store, querySelector) => {
    const { dir, slug, filters } = urlParams;
    const fullSlug = dir && slug ? `/${dir}/${slug}${filters ? '/'+filters : ''}` : '/';
    await store.dispatch(fetchSlugInfo(fullSlug, { useGraphQL: true }));

    const { slugInfo, redirects, basename } = store.getState();

    const needRedirect = !slugInfo || slugInfo.error || (redirects && redirects.count !== 0);

    const { destination = `${basename}/slp/weekly-deals`, status = 301 } = redirects;
    if (needRedirect) return Promise.resolve({ status, destination });

    return Promise.resolve(slugInfo);
};

const HomeContainer = ({ slugInfo = {}}) => {
    const { featuresTabHtml, productTab={} } = slugInfo.components || {};
    const [ productGroup={} ] = (productTab.productGroups || []);
    const { productsList=[] } = (productGroup || {})
	return <HomePage />
}

export default {
    component: withPage(HomeContainer, { wrapperClassName: 'home-root', showWordCloud: true, useGraphQL: true, useV2: true, noProps: true }),
    loadData: loadData
};
